import { useTranslation } from 'next-i18next';
import { cn } from '@/utils/tailwind.util';
export interface QuizCountProps {
  /** 퀴즈 개수 */
  quizCount: number;
  /** 추가 CSS 클래스 */
  className?: string;
}

/**
 * QuizCount - 퀴즈 개수 표시 컴포넌트
 *
 * @description
 * 퀴즈셋에 포함된 총 퀴즈 개수를 표시합니다.
 * 반응형 패딩을 적용하여 모바일과 데스크톱에서 적절한 간격을 유지합니다.
 *
 * @example
 * ```tsx
 * <QuizCount quizCount={10} />
 * ```
 */
export const QuizCount = ({
  quizCount,
  className
}: QuizCountProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className={cn('flex shrink-0 items-center justify-center', 'pr-sm tablet-lg:pr-xs', className)} data-sentry-component="QuizCount" data-sentry-source-file="QuizCount.tsx">
      <p className="text-body-lg-bold text-default">
        {t('nextQuiz.questionCount', {
        count: quizCount
      })}
      </p>
    </div>;
};